// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "button[data-v-5955b46f]{background:#435c73;border:2px solid #a88c59;border-radius:50px;box-shadow:0 0 10px rgba(0,0,0,.25);color:#fff;cursor:pointer;font-size:14px;height:45px;transition:.2s ease-in-out;width:130px}button[data-v-5955b46f]:disabled{cursor:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
